import { render, staticRenderFns } from "./OsobaStavke.vue?vue&type=template&id=6df625bc&scoped=true&"
import script from "./OsobaStavke.vue?vue&type=script&lang=js&"
export * from "./OsobaStavke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df625bc",
  null
  
)

export default component.exports